import React from 'react';

import { IconButton } from '@mui/material';
import { Circle } from 'lucide-react';
import { AlineTooltip } from 'src/components/generic';
import { Apollo } from 'src/gql/generated';
import { makeStyles } from 'tss-react/mui';

import { CompleteReminderIcon } from './CompleteReminderIcon';

const useStyles = makeStyles()(theme => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
  },
}));

interface CompleteReminderButtonProps {
  reminder: Pick<Apollo.Reminder, 'completedAt' | 'id' | '__typename'>;
  children?: React.ReactNode;
  disableTooltip?: boolean;
}

export function CompleteReminderButton({
  children,
  disableTooltip,
  reminder,
}: CompleteReminderButtonProps): JSX.Element {
  const { classes } = useStyles();
  const isComplete = Boolean(reminder.completedAt);
  const [updateReminder] = Apollo.useUpdateReminderMutation();

  return (
    <div className={classes.container}>
      <AlineTooltip
        arrow
        placement="top"
        title={disableTooltip ? '' : isComplete ? 'Reopen' : 'Mark complete'}
      >
        <IconButton
          size="small"
          onClick={async e => {
            e.stopPropagation();
            await updateReminder({
              variables: {
                input: {
                  props: {
                    completedAt: !isComplete ? new Date().toISOString() : null,
                  },
                  reminderId: reminder.id,
                },
              },
            });
          }}
        >
          {isComplete ? <CompleteReminderIcon /> : <Circle size={20} />}
        </IconButton>
      </AlineTooltip>
      {children}
    </div>
  );
}
